export default __webpack_public_path__ + "static/media/chevronUpWhite.636a1529.svg";